import React, { useRef, useState } from "react";
import { Link } from "shared/components/Link";
import { AppRoute } from "../../constants";
import { VideoSide } from "../../components/popup/VideoSide";
import Layout from "../../components/mainPage/Layout";
import video from "../../images/imagePopup/visualInformation/mapPlugin.webm";


export function Page() {
  const vidRef = useRef(null);
  const [isPlayButton, setIsPlayButton] = useState(true);

  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="mb-4 ">
            Интерактивная географическая карта
          </h1>

          <div className="align-start">
            <p style={{ fontSize: "20px" }}>
              Расширение интерактивная географическая карта (map-plugin) предназначено для создания интерактивных географических карт с возможностью отображения в корпоративной сети без доступа в интернет.
            </p>
            <p style={{ fontSize: "20px" }}>
              Пример применения map-plugin: редактор электрических схем энергорайонов с привязкой к географическим координатам и отображением подстанции и ЛЭП на карте.
            </p>
            <VideoSide
              isOpen={true}
              active={true}
              vidRef={vidRef}
              image={video}
              setIsPlayButton={setIsPlayButton}
              isPlayButton={isPlayButton}
              width={"100%"}
            />

          </div>
          <div className="d-flex justify-content-center">
            <Link to={AppRoute.MainPage}>
              <button
                className="accent-button button-hover mt-4"
                type="button"
                aria-label="вернуться на главную страницу"
              >
                На Главную
              </button>
            </Link>
          </div>

        </div>
      </div>
    </Layout>
  );
}

export const meta = {
  title: 'Интерактивная географическая карта',
  description: 'Расширение интерактивная географическая карта (map-plugin) предназначено для создания интерактивных географических карт с возможностью отображения в корпоративной сети без доступа в интернет.'
}
